import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.8 4.571H1.2c-.72 0-1.2.458-1.2 1.143C0 6.4.48 6.857 1.2 6.857h21.6c.72 0 1.2-.457 1.2-1.143s-.48-1.143-1.2-1.143M1.2 2.286h21.6c.72 0 1.2-.457 1.2-1.143S23.52 0 22.8 0H1.2C.48 0 0 .457 0 1.143s.48 1.143 1.2 1.143m21.6 6.857H1.2c-.72 0-1.2.457-1.2 1.143s.48 1.143 1.2 1.143h21.6c.72 0 1.2-.458 1.2-1.143 0-.686-.48-1.143-1.2-1.143m0 4.571H1.2c-.72 0-1.2.457-1.2 1.143S.48 16 1.2 16h21.6c.72 0 1.2-.457 1.2-1.143s-.48-1.143-1.2-1.143"
    }, null, -1)
  ]))]))
}
export default { render: render }